import { useEffect } from 'react';
import { ApiErrors } from '@core/api/ClientError';
import { AccountForbiddenErrors } from '@core/auth/errors';
import {
  getIsUserLoading,
  getUser,
  getUserError,
  getUserErrorMessage,
} from '@core/auth/redux';
import type { AuthClientErrors } from '@core/auth/types';
import { isNil } from '@core/helpers/isNil';

import { useReduxAction, useReduxState } from '@engage/redux/hooks';
import { loadUser } from '@members/user-mapper/redux';

export const useUserFetcher = () => {
  const load = useReduxAction(loadUser);
  const userLoaded = Boolean(useReduxState(getUser));
  const userIsLoading = useReduxState(getIsUserLoading);
  const isError = useReduxState(getUserError);
  const errorMessage = useReduxState(getUserErrorMessage);
  const ignorableErrors: AuthClientErrors[] = [
    AccountForbiddenErrors.AccountNotActive,
    AccountForbiddenErrors.AccountLocked,
    ApiErrors.UNAUTHORIZED,
  ];

  useEffect(() => {
    if (isError && !isNil(errorMessage) && !ignorableErrors.includes(errorMessage)) {
      throw new Error(errorMessage);
    }
  }, [isError, errorMessage]);

  return {
    isFetched: userLoaded || userIsLoading,
    load,
  };
};
